import React from "react";
import Button from "../common/Button";
import Icon from "../common/Icon";
import "./ConfirmDuplicatesModal.css";

const ConfirmDuplicatesModal = ({ isOpen, onConfirm, onCancel, duplicateCount, uniqueCount }) => {
  if (!isOpen) return null;

  return (
    <div className="confirm-modal-overlay" onClick={onCancel}>
      <div className="confirm-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-modal-header">
          <div className="confirm-modal-icon warning">
            <Icon name="AlertCircle" size={32} />
          </div>
          <h3>Doublons détectés</h3>
        </div>

        <div className="confirm-modal-body">
          <p>
            <strong>{duplicateCount} doublon{duplicateCount > 1 ? 's ont été détectés' : ' a été détecté'}</strong> dans votre liste de mots-clés.
          </p>
          <p>
            {duplicateCount > 1 ? 'Ils seront automatiquement supprimés' : 'Il sera automatiquement supprimé'}.
          </p>
          <div className="confirm-modal-stats">
            <div className="stat-item">
              <span className="stat-label">Mots-clés originaux :</span>
              <span className="stat-value">{uniqueCount + duplicateCount}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Doublons supprimés :</span>
              <span className="stat-value warning-text">-{duplicateCount}</span>
            </div>
            <div className="stat-item highlight">
              <span className="stat-label">Mots-clés uniques conservés :</span>
              <span className="stat-value success-text">{uniqueCount}</span>
            </div>
          </div>
          <p className="confirm-modal-question">
            Voulez-vous continuer avec les {uniqueCount} mots-clés uniques ?
          </p>
        </div>

        <div className="confirm-modal-footer">
          <Button
            type="button"
            variant="secondary"
            onClick={onCancel}
          >
            Annuler
          </Button>
          <Button
            type="button"
            variant="primary"
            onClick={onConfirm}
            icon={<Icon name="Check" size={18} />}
          >
            Continuer et créer
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDuplicatesModal;
